import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { TaskContextProvider } from "./context/ContextTask";

export default function App() {
  return (
    <BrowserRouter>
      <TaskContextProvider>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </TaskContextProvider>
    </BrowserRouter>
  );
}
